import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "@/assets/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import "@/styles/index.scss"; // global css
import "@/icons"; // icon
import "@/permission"; // permission control
import _ from "lodash";

import VueQuillEditor from "vue-quill-editor";
import echarts from "vue-echarts";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor /* { default global options } */);

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.component("chart", echarts);

// Vue.mixin(mixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
